import {
    ButtonBase,
    Divider,
    Grid,
    IconButton,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import MessageStoreBase from "stores/RealTimeMessages/MessageStoreBase";
import { useStore } from "../../../utils/useStore";
import EmptyNotifications from "./EmptyNotifications";
import NotificationList from "./NotificationList";
import theme from "../../../Theme/AppTheme";

interface OwnProps {
    onClose: () => void;
}

type Props = OwnProps;

const NotificationDrawerContent: FunctionComponent<Props> = observer(
    (props) => {
        const store = useStore(MessageStoreBase);
        const emptyNotifications = store.notifications.length === 0;

        return (
            <div
                style={{
                    width: "350px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Grid
                    container
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    wrap={"nowrap"}
                    sx={{
                        paddingX: theme.spacing(2),
                        paddingY: theme.spacing(1),
                    }}
                >
                    <Grid item zeroMinWidth>
                        <Typography variant={"h1"}>Notifications</Typography>
                    </Grid>
                    <Grid item>
                        <IconButton
                            onClick={props.onClose}
                            size="large"
                            edge="end"
                        >
                            <CloseIcon fontSize={"medium"} />
                        </IconButton>
                    </Grid>
                </Grid>
                <Divider variant={"fullWidth"} />

                {!emptyNotifications ? (
                    <>
                        <Grid
                            container
                            justifyContent={"flex-end"}
                            sx={{
                                paddingX: theme.spacing(2),
                                paddingY: theme.spacing(1),
                            }}
                        >
                            <ButtonBase
                                onClick={store.dismissAllNotifications}
                                sx={{
                                    textTransform: "none",
                                    color: theme.palette.primary.main,
                                    fontSize: "13px",
                                }}
                            >
                                Dismiss All
                            </ButtonBase>
                        </Grid>
                        <Divider variant={"fullWidth"} />
                        <div style={{ flex: 1, minHeight: 0 }}>
                            <Scrollbars autoHide>
                                <NotificationList
                                    notifications={store.notifications}
                                    onDismiss={store.dismissNotification}
                                />
                            </Scrollbars>
                        </div>
                    </>
                ) : (
                    <Grid container>
                        <EmptyNotifications />
                    </Grid>
                )}
            </div>
        );
    },
);

export default NotificationDrawerContent;
